<script>
export default {
  name: "DidoResourcePaginated",
};
</script>

<script setup>
import Datafile from "./Datafile.vue";
import Attachment from "./Attachment.vue";

const props = defineProps({
  apiUrl: { type: String, required: true },
  resource: { type: Object, required: true },
  type: { type: String, required: true },
});

// define events emitted
const emit = defineEmits(["datafile-selection"]);
</script>

<template>
  <Datafile
    v-if="props.type === 'datafiles'"
    :api-url="props.apiUrl"
    :datafile="props.resource"
    @selected="emit('datafile-selection')"
  />
  <Attachment
    v-else
    :resource="props.resource"
    :api-url="props.apiUrl"
    :type="props.type"
  />
</template>
